import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { FormItem, SelectInput } from '@framework/form';
import { Button, Space } from 'antd';
import React, { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { resolveChildrenReferences } from '../../../expressions/references/resolve/resolveTreeReferences';
import { RuleType } from '../../IRule';
import { IRuleConfigComponentProps } from '../../IRuleType';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';
import { IUniqueSingleFieldRule } from './UniqueFieldRule.rule';

const fieldName = `rules.${RuleType.UniqueField}`;

export function UniqueFieldRuleComponent(props: IRuleConfigComponentProps) {
  const { widget } = props;

  const inputChildrenWidget = useMemo(() => {
    if (!widget) {
      return [];
    }
    return resolveChildrenReferences([], widget)
      .filter(ref => ref.path.length === 0)
      .map(ref => ({
        label: ref.code ?? ref.label ?? ref.id,
        value: ref.code,
      }))
      .sort((a, b) => {
        if (a.label && b.label) {
          return a.label.localeCompare(b.label);
        }
        return 0;
      });
  }, [widget]);

  const { fields, append, remove } = useFieldArray({
    name: `${fieldName}.fields`,
  });

  return (
    <Space direction="vertical" style={{ width: '100%', margin: '20px 0 0 0' }}>
      {fields.map((field, i) => (
        <div key={field.id}>
          <FormItem
            name={`${fieldName}.fields[${i}].field`}
            label="Codice del campo univoco"
            help="Indica che nelle ripetizioni non può essere impostato lo stesso valore al campo."
          >
            <$SpaceCompact block size="large">
              <SelectInput
                name={`${fieldName}.fields[${i}].field`}
                options={inputChildrenWidget}
                showSearch
                optionFilterProp="label"
                size="large"
              />
              <CustomValidationRuleMessage
                name={`${fieldName}.fields[${i}].customMessage`}
              />
              <Button
                danger
                size="large"
                onClick={() => {
                  remove(i);
                }}
                icon={<DeleteOutlined />}
              />
            </$SpaceCompact>
          </FormItem>
        </div>
      ))}
      <Button
        size="large"
        style={{ width: '100%' }}
        children={
          <Space>
            <PlusOutlined aria-hidden="true" /> Aggiungi campo univoco...
          </Space>
        }
        onClick={() => {
          append({} as IUniqueSingleFieldRule);
        }}
      />
    </Space>
  );
}
